import { render, staticRenderFns } from "./DashTaxTracker.vue?vue&type=template&id=7c378bce&scoped=true&"
import script from "./DashTaxTracker.vue?vue&type=script&lang=js&"
export * from "./DashTaxTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c378bce",
  null
  
)

export default component.exports